import styled from 'styled-components';

export default styled.div`
  margin-top: 24px;
  background: #fbedd5;
  border: 1px solid #f9c151;
  border-radius: 4px;
  padding: 22px 20px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;

  span {
    display: flex;
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    background: #2196f3;
    border-radius: 28px;
    color: #fbedd5;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/alert.js